module.exports = __webpack_public_path__ + "img/green-check-circle.b9c0dd4e.png";